import { useEffect, useState } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useClassroomRosterChoiceGet = (options) => {
  const queryResponse = useRestQuery(
    `${MONOLITH_ORIGIN}/api/v2/roster-choice/`,
    options,
  );
  const [response, setResponse] = useState(queryResponse);

  useEffect(() => {
    setResponse(queryResponse);
  }, [queryResponse]);

  return [response, (data) => setResponse({ data })];
};

export default useClassroomRosterChoiceGet;
